import React from 'react';
import './AnnualUpsellCard.css';

interface AnnualUpsellCardProps {
  planInterval: string | null | undefined;
  currentPeriodEnd: string | null | undefined;
  onSwitchToAnnual: () => void;
  isSubmitting?: boolean;
}

function formatDate(dateString: string | null | undefined) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export default function AnnualUpsellCard({
  planInterval,
  currentPeriodEnd,
  onSwitchToAnnual,
  isSubmitting,
}: AnnualUpsellCardProps) {
  const isAnnual = planInterval === 'year';

  if (isAnnual) {
    return (
      <div className="annual-upsell-card annual-upsell-card--confirm">
        <h3 className="annual-upsell-card__title">You&rsquo;re on the annual plan</h3>
        <p className="annual-upsell-card__body">
          Next renewal: {formatDate(currentPeriodEnd) || 'tracked automatically'}.
        </p>
      </div>
    );
  }

  return (
    <div className="annual-upsell-card annual-upsell-card--offer">
      <h3 className="annual-upsell-card__title">Save 33% by switching to annual</h3>
      <p className="annual-upsell-card__body">
        $3.99/month, billed as $47.88/year. That&rsquo;s four months free compared to monthly
        billing.
      </p>
      <button
        type="button"
        className="annual-upsell-card__cta"
        onClick={onSwitchToAnnual}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Loading…' : 'Switch to Annual'}
      </button>
      <p className="annual-upsell-card__fineprint">
        Cancel anytime. Switch back to monthly whenever you want.
      </p>
    </div>
  );
}
